import { useState, useMemo } from "react";

import Table from "../../generic_components/Table/Table";

const OnlineSuccessMsg = ({ serverName, backOnlineCam }) => {
    const [expanded, setExpanded] = useState(false); 

    const handleToggle = () => {
        setExpanded(!expanded);
    }

    // Headers for offline devices table
    const backOnlineCam_columns = useMemo(() => [
        { key: 'cameraName', label: 'Camera Name' },
        { key: 'status', label: 'Status' },
    ], []);

    // Filter out all offline cameras
    const backOnlineCam_data = useMemo(() => {    
      return backOnlineCam.map((device) => ({
          cameraName: device?.cameraName,
          status: (
          <span style={{ color: '#22BE63', fontWeight: '600' }}>
              Online
          </span>
          ),
        }))
    }, [backOnlineCam]);

    return (
        <div>
            <p>
                <b>{backOnlineCam.length}</b> camera{backOnlineCam.length > 1 ? 's' : ''} attached to Server <b>{serverName}</b> {backOnlineCam.length > 1 ? 'are': 'is'} back online.
            </p>
            <button 
            className='view-offline-cams-btn'
            onClick={() => {
                handleToggle();
            }}
            >
            {!expanded ? 'View': 'Hide'} all {backOnlineCam.length} device{backOnlineCam.length > 1 ? 's' : ' '} <i className={`fa-solid fa-angle-down submenu-icon ${expanded ? 'open' : ''}`}></i> 
            </button>

            {
            expanded && (
                <Table
                    columns={backOnlineCam_columns}
                    data={backOnlineCam_data}
                    tableStyle={{minWidth: 0}}
                    thStyle={{fontSize: '10px'}}
                    tdStyle={{fontSize: '10px', color: 'black'}}
                    tableWrapperStyle={{maxHeight: '200px'}}
                />
            )
            }
        </div>
    )
}

export default OnlineSuccessMsg;